import React from "react";
import CmsManager from "../CMS/CmsManager";

function ServicesList() {
  return (
    <CmsManager
      title="Service Pages"
      resource="services"
      fields={[
        { name: "title", label: "Service Title", fullWidth: false },
        { name: "slug", label: "URL Slug", fullWidth: false },
        { name: "description", label: "Description", type: "richtext" },
        { name: "features", label: "Feature List", type: "list", rows: 5 },
        { name: "heroImage", label: "Hero Image", type: "image", fullWidth: false },
        { name: "altText", label: "Hero Image Alt Tag", fullWidth: false },
        { name: "cta", label: "CTA", fullWidth: false },
        { name: "metaTitle", label: "Title Tag", fullWidth: false },
        { name: "metaDescription", label: "Meta Description", type: "textarea", rows: 3 },
        { name: "metaKeywords", label: "Meta Keywords", type: "keywords", rows: 2 },
      ]}
    />
  );
}

export default ServicesList;
